import IntimacoesIndex from './Index.vue';

export const routes = [
  {
    path: 'intimacoes',
    name: 'intimacoes_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: IntimacoesIndex,
  },
];
